import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"
import Verify from "../pages/Authentication/Verify"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import History from "../pages/Application/History"
import AssignStaff from "../pages/Application/AssignStaff"
import ViewApplication from "../pages/Application/View"
import ReviewOfficer from "pages/Application/ReviewOfficer"
import ReviewHOD from "pages/Application/ReviewHOD"
import ReviewDG from "pages/Application/ReviewDG"

// Admin
import StaffDirectory from "pages/StaffDirectory/index"

// Officer Routes
import Assigned from "pages/Officer/Assigned"
import ProcessingOfficer from "pages/Officer/Processing"
import RejectedOfficer from "pages/Officer/Rejected"
import ReturnedOfficer from "pages/Officer/Returned"
import ApprovedOfficer from "pages/Officer/Approved"

// HoD Routes
import ProcessingHoD from "pages/HoD/Processing"
import RejectedHoD from "pages/HoD/Rejected"
import ReturnedHoD from "pages/HoD/Returned"
import ApprovedHoD from "pages/HoD/Approved"
import ReviewedHoD from "pages/HoD/Reviewed"
import OfficerReviewedHoD from "pages/HoD/OfficerReviewed"
import Report from "pages/HoD/Report"

// Director Routes
import ApprovedDG from "pages/Director/Approved"
import RejectedDG from "pages/Director/Rejected"
import AllApplications from "pages/Officer/AllApplications"
import Configurations from "pages/Configurations"
import ConsumptionAreas from "pages/Configurations/ConsumptionAreas"
import ConsumptionItems from "pages/Configurations/ConsumptionItems"
import Company from "pages/Company/Company"
import CompanyApplications from "pages/Company/CompanyApplications"
import Messaging from "pages/Messaging/Messaging"
import MessageHistory from "pages/Messaging/MessageHistory"
import MessageHistoryItem from "pages/Messaging/MessageHistoryItem"
import PlasticsStats from "pages/PlasticsStats"
import ManualApplications from "pages/Officer/ManualApplications"
import UploadManualCertificate from "pages/Officer/UploadManualCertificate"
import ChecklistQuestionsPage from "pages/ChecklistReview/ChecklistQuestionsPage"
import SectorOfActivity from "pages/Sector-of-Activity/SectorOfActivity"

// Custom Dashboards
import EnvAuditOfficerDashboard from "pages/Dashboard/EnvironmentalAudit/EnvAuditOfficerDashboard"
import EnvAuditHeadDashboard from "pages/Dashboard/EnvironmentalAudit/EnvAuditHeadDashboard"
import EnvAuditDirectorDashboard from "pages/Dashboard/EnvironmentalAudit/EnvAuditDirectorDashboard"

// Division Dashboards
import EnvComplianceDashboard from "pages/Dashboard/Divisions/EnvComplianceDashboard"

// All Env Applications
import AllEnvApplications from "pages/Officer/AllEnvApplications"

import ToRApproved from "pages/Dashboard/EnvironmentalAudit/ToRApproved"

const userRoutes = [
  { path: "/dashboard", component: Dashboard },

  { path: "/history", component: History },

  { path: "/assign", component: AssignStaff },

  { path: "/review-officer", component: ReviewOfficer },

  { path: "/review-hod", component: ReviewHOD },

  { path: "/review-dg", component: ReviewDG },

  { path: "/view-application", component: ViewApplication },
  {path: "/companies", component:Company},
  {path:"/company/applications",component:CompanyApplications},


  // // //profile
  { path: "/profile", component: UserProfile },

  // Officer Routes
  { path: "/officer-assigned", component: Assigned },
  { path: "/officer-processing", component: ProcessingOfficer },
  { path: "/officer-rejected", component: RejectedOfficer },
  { path: "/officer-returned", component: ReturnedOfficer },
  { path: "/officer-approved", component: ApprovedOfficer },
  { path: "/all-applications", component: AllApplications },
  { path: "/all-env-applications", component: AllEnvApplications },
  { path: "/manual-applications", component: ManualApplications },
  { path: "/manual-certificate-upload", component: UploadManualCertificate },

  // HoD Routes
  { path: "/hod-processing", component: ProcessingHoD },
  { path: "/hod-rejected", component: RejectedHoD },
  { path: "/hod-returned", component: ReturnedHoD },
  { path: "/hod-approved", component: ApprovedHoD },
  { path: "/hod-reviewed", component: ReviewedHoD },
  // all applications reviewed by officers in my department
  { path: "/officer-reviewed", component: OfficerReviewedHoD },
  { path: "/hod-reports", component: Report },

  // DG Routes
  { path: "/dg-approved", component: ApprovedDG },
  { path: "/dg-rejected", component: RejectedDG },
  { path: "/dg-recall-approved-application", component: ViewApplication },

  // staff directory
  { path: "/staff", component: StaffDirectory },

  // Admin Config
  { path: "/configurations", component: Configurations },
  { path: "/consumption-areas", component: ConsumptionAreas },
  { path: "/consumption-items", component: ConsumptionItems },

  // Messaging routes
  { path: "/messaging", component: Messaging },
  { path: "/message-history", component: MessageHistory },
  { path: "/message-history-item", component: MessageHistoryItem },

  // Plastics Stats
  { path: "/plastics-stats", component: PlasticsStats },

  // Environmental Audit Checklist Review
  {path:"/env-checklist",component:ChecklistQuestionsPage},
  
  // Sector of Activity
  {path:"/env-activity-sector",component:SectorOfActivity},

  // Custom Dashboards
  {path:"/dashboard-officer-env-audit", component:EnvAuditOfficerDashboard},
  {path:"/dashboard-head-env-audit", component: EnvAuditHeadDashboard},
  {path:"/dashboard-director-env-audit", component: EnvAuditDirectorDashboard},

  // Env Compliance Dashboard - For Env Audit and Auth to use plastics, etc.
  { path: "/env-compliance-dashboard", component: EnvComplianceDashboard },
  { path: "/tor-approved", component: ToRApproved },
  
  // this route should be at the end of all other routes
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
]

const authRoutes = [
  { path: "/logout", component: Logout },
  { path: "/login", component: Login },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
  { path: "/staff/verify", component: Verify },
]

export { userRoutes, authRoutes }
